export const source = (geoJSON) => {
  return {
    type: "geojson",
    data: geoJSON,
  };
};

export const layer = {
  id: "county",
  type: "line",
  source: "county",
  layout: {
    "line-join": "round",
  },
  // MapTiler Streets' "Other border" admin boundary style, darkened to stand
  // out from neighboring counties
  paint: {
    "line-color": "hsl(0, 0%, 50%)",
    "line-dasharray": [2, 1],
    "line-width": [
      "interpolate",
      ["linear"],
      ["zoom"],
      3,
      0.75,
      4,
      0.8,
      11,
      1.75,
      18,
      3,
    ],
  },
};
